import { Box, type SxProps, type Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InHouseTooltip } from "../../../../components/InHouseTooltip/InHouseTooltip";
import { COVERAGE } from "../../../../theme/tokens";

type Props = {
	label: string;
	/** When set, the label reads as a warning and carries the misconfig tooltip. */
	unconfiguredRoles?: boolean;
	/** Ink used when the row is NOT unconfigured (varies by grid density). */
	baseColor: string;
	/** Size/placement overrides — the only thing the Summary vs Detail call sites differ on. */
	sx?: SxProps<Theme>;
};

/** The Coverage row's identity (role/job) label. Shared by the Summary and Detail grids so the
 * unconfigured-roles warning styling + tooltip live in ONE place; call sites pass only size/placement. */
export const CoverageIdentityLabel = ({ label, unconfiguredRoles, baseColor, sx }: Props) => {
	const { t } = useTranslation();
	return (
		<InHouseTooltip title={unconfiguredRoles ? t("schedule.template.v3.unconfiguredRoles.tooltip") : ""} disableHoverListener={!unconfiguredRoles}>
			<Box component="span" sx={{ fontWeight: 800, letterSpacing: "0.02em", color: unconfiguredRoles ? COVERAGE.WARNING_INK : baseColor, ...sx }}>
				{label}
			</Box>
		</InHouseTooltip>
	);
};
